class Enum {
    toPolarisSelect() {
        return Object.values(this);
    }
}

export default Enum;
